@if (!printMode) {
  <lib-validation-problems [saving$]="saving$"></lib-validation-problems>
}

@if (uiConfiguration.hasReferenceRegistrationInformation) {
  <div>
    <h3>{{ 'common.labels.existingRegistrationDetails' | transloco }}</h3>
    <lib-existing-registration-details
      [uiConfiguration]="uiConfiguration.referenceRegistrationInformationUIConfiguration!">
    </lib-existing-registration-details>
  </div>
}

@if (uiConfiguration.hasDischargeDetails && uiConfiguration.dischargeDetailsConfiguration && uiConfiguration.dischargeDetailsConfiguration.showAny) {
  <div>
    <h3>{{ 'common.labels.typeDetails' | transloco: { type: order.orderType.name } }}</h3>
    <div class="flex-item-no-padding">
      <lib-discharge-details [order]="order"
      [uiConfiguration]="uiConfiguration.dischargeDetailsConfiguration"></lib-discharge-details>
    </div>
  </div>
}

@if (isHistorical()) {
  <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"
    [results]="$safeNavigationMigration(order.lien?.registrationResults?.at(0))" class="flex-item">
  </lib-lien-results>
}